export const SAMPLE_REGEXES = [
	// eslint-disable-next-line prefer-regex-literals
	new RegExp(""),
	/nerds/i,
] as const;
